export const setTab = (category_id, tab_id) => {
  return {
    type: 'SET_TAB',
    payload: {
      category_id,
      tab_id
    }
  }
}